import React, { useCallback, useContext, useMemo, useState } from 'react';

import { MobXProviderContext, observer } from 'mobx-react';

import { Button, Form, Radio } from 'semantic-ui-react';

import '../../css/AddJoinClassModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import Modal from '../Modal';

const AddJoinClassModal = observer((props) => {
  const {
    open,
    close,
    openAddModal,
    openGoogleClassroomConnectionModal,
    openJoinModal,
    t
  } = props;

  const { googleClassroomManager } = useContext(MobXProviderContext);

  const ModalBanner = useMemo(() => SatCoreComponent('ModalBanner'), []);
  const [selectedClassroomOptionValue, setSelectedClassroomOptionValue] = useState(null);
  const onSave = useCallback(() => {
    close();
    switch (selectedClassroomOptionValue) {
      case 'new':
        openAddModal();
        break;
      case 'join':
        openJoinModal();
        break;
      case 'importGoogleClassroom':
        openGoogleClassroomConnectionModal();
        break;
      default:
        break;
    }
  }, [selectedClassroomOptionValue, close, openAddModal, openJoinModal, openGoogleClassroomConnectionModal]);

  const renderClassroomModalOption = (optionValue, optionLabelKey) => {
    if (!optionValue) {
      return null;
    }
    optionLabelKey = optionLabelKey || optionValue;
    return (
      <Form.Field>
        <Radio
          checked={selectedClassroomOptionValue === optionValue}
          label={t(optionLabelKey)}
          name='radioGroup'
          onChange={(_event, _data) => setSelectedClassroomOptionValue(optionValue)}
          value='new' />
      </Form.Field>
    );
  };

  return (
    <Modal
      className='add-join-class-modal'
      closeOnDimmerClick={false}
      closeOnEscape={true}
      onClose={close}
      open={open}>
      <ModalBanner onClose={close} title={t('addJoinClass', 'Add / Join Class')} />
      <Modal.Content>
        {renderClassroomModalOption('new', 'addNewClass')}
        {renderClassroomModalOption('join', 'joinClass')}
        {googleClassroomManager.allowGoogleClassroomIntegration && (
          renderClassroomModalOption('importGoogleClassroom')
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button basic className='cancelButton' onClick={close} primary>
          {t('cancel')}
        </Button>
        <Button className='ui primary button saveButton' disabled={selectedClassroomOptionValue === null} onClick={onSave}>
          {t('save')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
});

export default AddJoinClassModal;

SatCoreRegister('AddJoinClassModal', AddJoinClassModal);
